/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIPriceEntry
 */
export interface APIPriceEntry {
    /**
     * 
     * @type {string}
     * @memberof APIPriceEntry
     */
    quantity: string;
    /**
     * 
     * @type {number}
     * @memberof APIPriceEntry
     */
    value?: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIPriceEntry
     */
    display?: string;
}

/**
 * Check if a given object implements the APIPriceEntry interface.
 */
export function instanceOfAPIPriceEntry(value: object): value is APIPriceEntry {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    return true;
}

export function APIPriceEntryFromJSON(json: any): APIPriceEntry {
    return APIPriceEntryFromJSONTyped(json, false);
}

export function APIPriceEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPriceEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'value': json['value'] == null ? undefined : json['value'],
        'display': json['display'] == null ? undefined : json['display'],
    };
}

export function APIPriceEntryToJSON(value?: APIPriceEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'quantity': value['quantity'],
        'value': value['value'],
        'display': value['display'],
    };
}

